export default "__VITE_ASSET__BBjueTCG__"